export function toRelativeDate(date: string | Date | undefined) {
	if (!date) {
		return "";
	}

	const resolvedDate = date instanceof Date ? date : new Date(date);
	return formatDistanceToNowStrict(resolvedDate, { addSuffix: true });
}
